// Use this interface to override the default CMS components or add new ones.

import { DefaultComponentDefinitions, defaultComponentDefinitions } from '@grandvision/bloomreach'

interface ComponentDefinitions extends DefaultComponentDefinitions {}

const componentDefinitions: ComponentDefinitions = {
  ...defaultComponentDefinitions,
}

export default componentDefinitions
